import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
import memo from "memo-decorator";
import { DatePipe } from "@angular/common";
let UtcDatePipe = class UtcDatePipe extends DatePipe {
    transform(value, args) {
        if (!value) {
            return "";
        }
        return super.transform(value, "yyyy-MM-dd") + "T23:59:59Z";
    }
};
__decorate([
    memo()
], UtcDatePipe.prototype, "transform", null);
UtcDatePipe = __decorate([
    Pipe({
        name: "odataDate"
    })
], UtcDatePipe);
export { UtcDatePipe };
